import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SDKProvider } from '@tma.js/sdk-react'
import { App } from './App'
import { MiniAppSessionBoundary } from './components/MiniAppSessionBoundary'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 2,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SDKProvider acceptCustomStyles debug={import.meta.env.DEV}>
      <QueryClientProvider client={queryClient}>
        <MiniAppSessionBoundary>
          <App />
        </MiniAppSessionBoundary>
      </QueryClientProvider>
    </SDKProvider>
  </React.StrictMode>,
)
